import { AuthenticateWithRedirectCallback } from '@clerk/clerk-react';

export const SSOCallback = () => {
  return <AuthenticateWithRedirectCallback />;
};
